/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calculating_SyncInputs */



/**
* | output |
* | --- |
* | "Calculating sync timing... please wait..." |
*
* @param {Calculating_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const calculating_sync = /** @type {((inputs?: Calculating_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calculating_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Calcul du minutage de synchronisation... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierungszeit wird berechnet... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Calcolo del tempo di sincronizzazione... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вычисление синхронизации... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Calculando tiempo de sincronización... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在计算同步时序……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期タイミングを計算しています...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंक्रोनाइज़ेशन टाइमिंग की गणना की जा रही है... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Calculando o tempo de sincronização... aguarde...")
	return /** @type {LocalizedString} */ ("Calculating sync timing... please wait...")
});